import { useEffect, useState } from 'react';
import { api } from './api';
import type { AppRelease } from './types';

export function LandingPage() {
  const [release, setRelease] = useState<AppRelease | null>(null);
  useEffect(() => { api.get<AppRelease>('/app/latest').then(setRelease).catch(() => setRelease(null)); }, []);
  return <main className="landing">
    <nav className="landing-nav">
      <a className="brand" href="/"><span className="brand-mark">共</span><span>共笔故事</span></a>
      <a className="text-link" href="/admin">运营后台</a>
    </nav>
    <section className="hero">
      <div className="hero-copy">
        <p className="eyebrow">CO-WRITE · 一起写下去</p>
        <h1>一句接一句，<br /><em>把灵感写成世界。</em></h1>
        <p className="hero-lead">邀请朋友进入同一个故事。每个人写下一句，所有奇妙转折都被认真保存。</p>
        <div className="hero-actions">
          <a className={`download-button ${release ? '' : 'disabled'}`} href={release?.apkUrl ?? '#'} aria-disabled={!release}>下载 Android APK</a>
          <span className="release-note">{release ? `v${release.versionName} · Android 10+` : '版本信息加载中'}</span>
        </div>
      </div>
      <div className="paper-stack" aria-label="共笔故事示例">
        <article className="paper back"><span>03</span></article>
        <article className="paper middle"><span>02</span></article>
        <article className="paper front">
          <div className="paper-top"><span>正在共写</span><b>7 人</b></div>
          <h2>月亮邮局</h2>
          <p><strong>阿岚</strong> 那封没有地址的信，在午夜自己折成了一只纸鹤。</p>
          <p><strong>小满</strong> 它绕过沉睡的城市，落在月亮背面的蓝色邮筒旁。</p>
          <p><strong>你</strong> <span className="cursor">|</span></p>
        </article>
      </div>
    </section>
    <section className="feature-grid">
      <article><span>01</span><h3>只和受邀的人写</h3><p>每个故事都有独立成员，邀请确认后才能阅读和续写。</p></article>
      <article><span>02</span><h3>每句话都有位置</h3><p>并发提交也按服务器顺序落笔，内容不会覆盖或重复。</p></article>
      <article><span>03</span><h3>灵感始终在身边</h3><p>打开应用即可实时看到新句子，离线时仍能阅读缓存。</p></article>
    </section>
    <section className="download-panel">
      <div><p className="eyebrow">直接安装</p><h2>把下一句带在身边</h2><p>下载后请允许浏览器安装未知来源应用。升级包始终使用同一签名。</p></div>
      <div className="checksum"><span>SHA-256</span><code>{release?.sha256 || '发布构建后显示校验值'}</code></div>
    </section>
    <footer>
      <span>共笔故事</span>
      <span><a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">湘ICP备2024108418号</a> · story.dongdong.me</span>
    </footer>
  </main>;
}
